// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

up.compiler('[add-pricing-option]', function(element) {
  const option = element.getAttribute('add-pricing-option')
  const formFields = element.closest('.pricing-form--fields')
  const template = formFields.querySelector(`#new-${option}`)
  let optionsCount = formFields.querySelectorAll('.pricing-form--object').length

  const replaceFormFieldIndices = (newElement, option, index) => {
    newElement.querySelectorAll('label, input').forEach((formElement) => {
      if (formElement.getAttribute('for')) {
        formElement.setAttribute('for', formElement.getAttribute('for').replace('0', index))
      }
      if (formElement.getAttribute('id')) {
        formElement.setAttribute('id', formElement.getAttribute('id').replace('0', index))
      }
      if (formElement.getAttribute('name')) {
        formElement.setAttribute('name', formElement.getAttribute('name').replace('0', index))
      }
    })

    newElement.classList.replace(`${option}-0`, `${option}-${index}`)
    newElement.removeAttribute('id')
  }

  element.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()

    const clone = template.cloneNode(true)
    replaceFormFieldIndices(clone, option, optionsCount)
    optionsCount += 1

    template.parentNode.insertBefore(clone, template.nextSibling)
    $(clone).collapse('toggle')
  })
})
